<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增产品类型 -->
		<Popup 
			v-model="add_display"
			title="新增产品类型"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="add_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入名称</template></div>
			</div>
		</Popup>
		<!-- 新增产品类型 end -->
		
		<!-- 修改产品类型 -->
		<Popup 
			v-model="update_display"
			title="修改产品类型"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="update_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入名称</template></div>
			</div>
		</Popup>
		<!-- 修改产品类型 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js'
	import BaseMethods from '../../../../assets/js/base.js'
	import { mapMutations } from 'vuex'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				add_name: '',
				addName_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				updateName_tip: false,
				
				delete_display: false,
				delete_id: ''
			}
		},
		methods: {
			/********************************* @Events *********************************/
			// 点击新增
			handleAddClick () {
				this.add_display = true;
			},
			// 点击新增弹框确定按钮
			handleAddPopupConfirmClick () {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				this.addProductType();
			},
			
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			// 点击修改
			handleUpdateClick (obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.updateName_tip = false;
				this.update_display = true;
			},
			// 点击修改弹框确定按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				that.$confirm(
					'此操作将修改该产品类型?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.updateProductType();
					}
				);
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_id = obj.id;
				this.delete_display = true;
			},
			// 点击删除弹出框确认按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteProductCategory(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.currentPage = 1;
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			

			/********************************* @Function *********************************/
			// 请求数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					limit: 10,
					pageNum: that.currentPage,
					type: 1
				};
				Api.findProductCategory(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.productId,
								name: _o.productName || '',
								creatDate: BaseMethods.formatTime(_o.createTime)
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 添加产品类型
			addProductType () {
				const that = this;
				that.loading = true;
				var requestData = {
					createTime: null,
					dr: null,
					productId: null,
					productName: that.add_name,
					updateTime: null
				};
				Api.addProductCategory(requestData).then((res) => {
					if (res.data.success) {
						that.findAuthProduct();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改产品类型
			updateProductType () {
				const that = this;
				that.loading = true;
				var requestData = {
					createTime: null,
					dr: null,
					productId: that.update_id,
					productName: that.update_name,
					updateTime: null
				};
				Api.updateProductCategory(requestData).then((res) => {
					if (res.data.success) {
						that.findAuthProduct();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取登录者产品
			findAuthProduct() {
				const that = this;
				var requestData = {};
				Api.findAuthProduct(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var _list = [];
						res.data.data && res.data.data.forEach((v) => {
							_list.push({
								id: v.productId,
								name: v.productName
							});
						});
						that.setAuthProduct(_list);
						that.add_display = false;
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			...mapMutations({
				'setAuthProduct': 'setAuthProduct'
			})
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
